<template>
    <div
        v-if="isArray(data)"
        class="json-clickable"
    >
        <button
            v-if="isCollapse"
            @click="toggleCollapse"
        >
            [...]
        </button>
        <div v-else>
            <button @click="toggleCollapse">[</button>
            <div class="json-clickable__properties">
                <div
                    v-for="(obj, index) in data"
                    :key="index"
                >
                    <json-clickable
                        :data="obj"
                        :parent-path="`${ parentPath }[${ index }]`"
                        :closing-comma="index < data.length -1"
                    />
                </div>
            </div>
            <span>]</span>
        </div>
    </div>
    <div
        v-else-if="isObject(data)"
        class="json-clickable"
    >
        <button
            v-if="isCollapse"
            @click="toggleCollapse"
        >
            {...}
        </button>
        <div v-else>
            <button @click="toggleCollapse">{</button>
            <div class="json-clickable__properties">
                <div
                    v-for="(key, index) in objectKeys"
                    :key="index"
                    class="json-clickable__property"
                >
                    "<button @click="onKeyClick(key)">{{ key }}</button>":
                    <span v-if="data[key] === null">null</span>
                    <json-clickable
                        v-else-if="isArray(data[key]) || isObject(data[key])"
                        :data="data[key]"
                        :parent-path="parentPath + '.' + key"
                    />
                    <span v-else-if="isString(data[key])">"{{ data[key] }}"</span>
                    <span v-else>{{ data[key] }}</span>
                </div>
            </div>
            <span>}<span v-if="closingComma">,</span></span>
        </div>
    </div>
    <div
        v-else-if="isString(data)"
        class="json-clickable"
    >
        "<button @click="onKeyClick('')">{{ data }}</button>"
    </div>
    <div
        v-else
        class="json-clickable"
    >
        <button @click="onKeyClick('')">{{ data }}</button>
    </div>
</template>

<script>
export default {
    name: 'json-clickable',
    props: {
        data: {
            type: [Object, Array, String, Number],
            default: null,
        },

        parentPath: {
            type: String,
            default: '$data',
        },

        closingComma: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            isCollapse: false,
        };
    },

    computed: {
        objectKeys() {
            if (!this.data) return [];
            return Object.keys(this.data).filter(key => key !== '__typename');
        },
    },

    methods: {
        onKeyClick(path) {
            if (!path) {
                this.$root.$emit('flex::json::click', this.parentPath);
            } else {
                const dataPath = path.match(/^[0-9a-zA-Z]+$/)
                    ? `${ this.parentPath }.${ path }`
                    : `${ this.parentPath }["${ path }"]`;

                this.$root.$emit('flex::json::click', dataPath);
            }
        },

        toggleCollapse() {
            this.isCollapse = !this.isCollapse;
        },

        isObject(item) {
            return typeof item === 'object';
        },

        isArray(item) {
            return Array.isArray(item);
        },

        isString(item) {
            return typeof item === 'string';
        },
    },
};
</script>

<style lang="scss">
.json-clickable__properties {
    padding-left:1em;
}

.json-clickable__property {
    text-indent: -2em;
    padding-left: 2em;

    > button {
        text-decoration: underline;
    }

    > .json-clickable {
        text-indent: 0;
        padding-left: 1em;
    }
    &:not(:last-of-type):after {
        content: ',';
    }
}
</style>
